import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();

    // Memoize the state object so React doesn't see a new reference each render.
    const navState = useMemo(() => ({ from: location }), [location]);

    if (user === null) {
        return (
            <div
                className="min-h-screen grid place-items-center bg-[#F7F5F0] text-[#6F6B63]"
                data-testid="auth-checking"
            >
                Checking session…
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/admin/login" state={navState} replace />;
    }
    return children;
}
